module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Play_16"],"polygon":[{"$":{"points":"3 3 3 13 13 8 3 3","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Play_16.svg
// module id = Zcpb
// module chunks = 1